import {useState} from 'react';

export const useLocalStorage = (key: string, initValue = null) => {
  const [value, setValue] = useState(localStorage.getItem(key));

  const setItem = (newValue: string) => {
    localStorage.setItem(key, newValue);
    setValue(newValue);
  };

  const getItem = () => {
    return localStorage.getItem(key) || initValue;
  };

  const removeItem = () => {
    localStorage.removeItem(key);
    setValue(null);  // Set value to null after removal to keep state in sync (react state does not automatically update if localStorage value is removed it needs to be changed manually)
  };

  return {value, setItem, getItem, removeItem};
};
